import { Sender } from 'generated-graphql/types';
import { Sender as SenderDeprecated } from 'services/conversations/types';

export const convertToDeprecatedSender = (sender: Sender): SenderDeprecated => {
  switch (sender) {
    case Sender.Agent:
      return SenderDeprecated.AGENT;
    case Sender.User:
      return SenderDeprecated.USER;
    case Sender.Prospect:
      return SenderDeprecated.PROSPECT;
  }
};
